
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_subdomains/senzacni/serak",
      function () {
        return require("private-next-pages/_subdomains/senzacni/serak.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/_subdomains/senzacni/serak"])
      });
    }
  